import React from "react";
import Button from "./Button";
import ButtonDisabled from "./ButtonDisabled";
import "./Card.css";

const Card = (props) => {

  const github = props.project.git

  return (
    <div className="col-lg-3 m-2">
      <div className="card mb-3 h-100">
          <div className="col-md-12">
            <div className="card-body mb-4">
              <h5 className="card-title">{props.project.name}</h5>
              <p className="card-text">{props.project.description}</p>
            </div>
            <div className="text-end">
              <a
                href={props.project.url !== "" ? props.project.url : null}
                target="_blank"
                rel="noreferrer"
              >{props.project.url!==""?<Button github={github}/>:<ButtonDisabled />}
              </a>
            </div>
          </div>
        </div>
      </div>
  );
};

export default Card;
